import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import WidgetSettings from "../widgetSettings"
import { selectionTypes } from "../../utils/consts";
import { faRainbow, faSms, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import WidgetTools from "../widgetTools";
import { PieChart, Series, Connector, Legend, Label, Font, Animation, Size } from 'devextreme-react/pie-chart';

function SentimentSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [positive, setPositive] = useState(0);
    const [negative, setNegative] = useState(0);
    const [neutral, setNeutral] = useState(0);
    const [sentiments, setSentiments] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`SentimentSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [channel, setChannel] = useState(localStorage.getItem(`SentimentSummary_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`SentimentSummary_channelName_${props.identifier}_user${props.id}`) || "");

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {

                MonitorWSService.stompClient.send(`/app/unsubscribe/analysissentimentsummary`, {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`analysissentimentsummary_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`SentimentSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            let channel = localStorage.getItem(`SentimentSummary_channel_${props.identifier}_user${props.id}`) || "";
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysissentimentsummary/`, function (callssummary) {
                if (!showSettings) {
                    var data = JSON.parse(callssummary.body);
                    setPositive(data.positiveNumber);
                    setNegative(data.negativeNumber);
                    setNeutral(data.neutralNumber);
                    setSentiments([{
                        "sentiment": t("positive"),
                        "number": data.positive
                    },
                    {
                        "sentiment": t("negative"),
                        "number": data.negative
                    },
                    {
                        "sentiment": t("neutral"),
                        "number": data.neutral
                    }
                    ]);

                }
            }, { id: `analysissentimentsummary_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/analysissentimentsummary", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                groupId: groupId,
                channel: channel
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroupAndChannel = (groupId, groupName, channel, channelName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`SentimentSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`SentimentSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        localStorage.setItem(`SentimentSummary_channel_${props.identifier}_user${props.id}`, channel)
        localStorage.setItem(`SentimentSummary_channelName_${props.identifier}_user${props.id}`, channelName)
        MonitorWSService.stompClient.send("/app/subscribe/analysissentimentsummary", {}, JSON.stringify({
            token: props.token,
            widgetId: props.identifier,
            channel: channel,
            groupId: groupId
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        localStorage.removeItem(`SentimentSummary_groupName_${props.identifier}_user${props.id}`)
        localStorage.removeItem(`SentimentSummary_groupId_${props.identifier}_user${props.id}`)
        localStorage.removeItem(`SentimentSummary_channel_${props.identifier}_user${props.id}`)
        props.close(props.identifier);
    }

    const getIcon = (channel) => {
        let elem = <FontAwesomeIcon icon={duotone("face-smile")} />;
        if (channel === "facebook")
            elem = <FontAwesomeIcon icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon icon={faEnvelope} />;
        return elem;
    }

    const customizePoint = (e) => {
        if (e.argument === t("positive")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("negative")) {
            return {
                color: "#f1416c"
            }
        }
        if (e.argument === t("neutral")) {
            return {
                color: "#b2b3bb"
            }
        }
    }

    return (
        <>
            <div className={"card card-flush overflow-hidden widget-container widget-container"}>
                <div className="card-header">
                    <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                        <span className="card-label fw-bold text-primary">{getIcon(channel)} {channelName ? channelName : t("sentimentsummary")} - {groupName}</span>
                    </h3>
                    <div className="card-toolbar" style={{ zIndex: 9999 }}>
                        <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                    </div>
                </div>
                <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                    <Row>
                        <Col> <div className="fs-3hx fw-bold text-success statsnumber"><FontAwesomeIcon icon={duotone("face-smile")} /> {positive}</div>
                            <div className="fs-5 fw-semibold mb-7">{t("positive")}</div>
                        </Col>
                        <Col> <div className="fs-3hx fw-bold text-danger statsnumber"><FontAwesomeIcon icon={duotone("face-angry")} /> {negative}</div>
                            <div className="fs-5 fw-semibold mb-7">{t("negative")}</div>
                        </Col>
                        <Col>
                            <div className="fs-3hx fw-bold text-gray-800 statsnumber"><FontAwesomeIcon icon={duotone("face-meh")} /> {neutral}</div>
                            <div className="fs-5 fw-semibold mb-7">{t("neutral")}</div>
                        </Col>
                        <Col>
                            <PieChart
                                key={"sentimentsummary"}
                                id="sentimentsummary"
                                dataSource={sentiments}
                                type="doughnut"
                                resolveLabelOverlapping="shift"
                                rtlEnabled={props.rtl}
                                customizePoint={customizePoint}
                                innerRadius={0.6}
                            >   <Size
                                    height={140}
                                    width={160}
                                />
                                <Series
                                    argumentField="sentiment"
                                    valueField="number"
                                >
                                    <Label
                                        visible={false}
                                    >
                                    </Label>
                                </Series>
                                <Legend visible={false}
                                ></Legend>
                                <Animation enabled={true}></Animation>
                            </PieChart>
                        </Col>
                    </Row>
                </div>

            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupAndChannel={setGroupAndChannel} groupId={groupId} groupName={groupName} selectionType={selectionTypes.CHANNEL} channel={channel} channelName={channelName}></WidgetSettings>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(SentimentSummary);